import React, { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Breadcumb, MainLayout, Header } from 'components';
import ErrorModal from 'components/ErrorModal';

import { useAutoApproval } from 'hooks/useAutoApproval';

import Loader from 'components/Loader';
import FormScreen from './FormScreen';

const Detalhes: FC = () => {
  const {
    isLoading,
    resetCurrentFormData,
    error,
    clearError,
  } = useAutoApproval();
  const history = useHistory();

  const isEditScreen =
    history.location.pathname === '/aprovacao-automatica/edit';

  useEffect(() => {
    if (!isEditScreen) {
      resetCurrentFormData();
    }
  }, []);

  return (
    <MainLayout>
      <Breadcumb />
      {isLoading && <Loader />}
      {error && <ErrorModal handleOnClose={clearError} error={error} />}

      <Header />
      <FormScreen isEditScreen={isEditScreen} />
    </MainLayout>
  );
};

export default Detalhes;
